import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";

export const LevelListFilters = React.memo(() => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("level_admin.filters.search")}
        />
      </Grid>
    </Grid>
  );
});
